import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CreditCardIcon from '@mui/icons-material/CreditCard';

import { ServicePaymentStatus } from '../../types';
import { formatCardShort } from '../../constants';

interface Props {
	status: ServicePaymentStatus;
}

export const ServicePaymentBadge = ({ status }: Props): JSX.Element | null => {
	const activePayments = status.payments.filter((p) => p.status === 'ACTIVO');
	const lastActivePayment = activePayments[activePayments.length - 1];

	if (status.fullyPaid && lastActivePayment) {
		return (
			<Chip
				icon={<CheckCircleIcon />}
				label={`Pagado con 💳 ${formatCardShort(lastActivePayment.card)}`}
				color="success"
				size="small"
				sx={{ fontWeight: 500 }}
			/>
		);
	}

	if (status.paid && !status.fullyPaid && status.difference < 0 && lastActivePayment) {
		return (
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<Chip
					icon={<CreditCardIcon />}
					label={`Pago parcial: USD ${status.totalPaidUsd.toFixed(2)} / ${status.serviceCostUsd.toFixed(2)}`}
					color="warning"
					size="small"
					sx={{ fontWeight: 500 }}
				/>
			</Box>
		);
	}

	if (status.difference > 0) {
		return (
			<Chip
				label={`💳 Pagado de más: +USD ${status.difference.toFixed(2)}`}
				color="warning"
				size="small"
				variant="outlined"
				sx={{ fontWeight: 500 }}
			/>
		);
	}

	if (status.paid && lastActivePayment) {
		return (
			<Chip
				icon={<CreditCardIcon />}
				label={`Con tarjeta: USD ${status.totalPaidUsd.toFixed(2)}`}
				color="info"
				size="small"
				sx={{ fontWeight: 500 }}
			/>
		);
	}

	return (
		<Typography variant="caption" color="text.secondary">
			—
		</Typography>
	);
};
